export enum ValidateDocumentStatus {
    VALIDATE_INITIATED = 'Validate_Initiated',
    VALIDATE_PROGRESS = 'Validate_Progress',
    VALIDATE_COMPLETE = 'Validate_Complete',
    MERGING_PROGRESS = 'Merging_Progress',
    RESULT = 'RESULT'
}
